import React from "react";
import Topbar from "../topbar/Topbar";
import Sidebar from "../sidebar/Sidebar";
import { SalaryComponent } from "./SalaryComponent";
import { useCookie } from "../../utils";

function SalarySummary() {
  const branch_id = useCookie("branch_id");
  return (
    <SalaryComponent TopBar={Topbar} SideBar={Sidebar} branch_id={branch_id} />
  );
}

export default SalarySummary;
